import { ActivatedRoute, Router, RouteReuseStrategy } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { saveAs } from 'file-saver';

import { AccountService } from "../../../services/account.service";
import { AbstractService } from '../../../services/abstract.service';
import { AlertService, MessageSeverity } from '../../../services/alert.service';
import { AuthService } from '../../../services/auth.service';
import { Utilities } from '../../../services/utilities';
import { NgClass } from '@angular/common';

import { MatButtonModule } from '@angular/material/button';


@Component({
  selector: 'app-import-abstract',
  templateUrl: './import-abstract.component.html',
  styleUrls: ['./import-abstract.component.css'],
  imports: [
    MatButtonModule,
    NgClass
  ],
    providers: [
    ]
})
export class ImportAbstractComponent implements OnInit {
  file: File;
  isUploading: boolean;
  activeProjectTitle: string;

  constructor(
    private abstractService: AbstractService, 
    private alertService: AlertService, 
    private authService: AuthService,
    private accountService: AccountService,
    public router: Router,
    public activeRoute: ActivatedRoute) { 

    // force route reload whenever params change;
    this.activeRoute.params.subscribe(params => {
      console.log('Change to params');
      // TO DO: Fix whatever needed refreshing here
    })
  }

  ngOnInit() {
    if (this.authService.isSessionExpired) {
      this.router.navigateByUrl('/account/login');
    }
    this.activeProjectTitle = this.accountService.GetActiveProject() ? this.accountService.GetActiveProject().projectTitle : "";
  }

  handleFileInput(files: FileList) {
    if (files.length)
      this.file = files[0];
  }

  downloadTemplate() {
    const filename = "AbstractTemplate.xlsx"
    const type = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    
    this.alertService.startLoadingMessage("", "Downloading file...");

    this.abstractService.getAbstractSpreadsheetTemplate().subscribe(
      (data: ArrayBuffer) => {
        this.alertService.stopLoadingMessage();
        const blob = new Blob([data], {type: type});
        saveAs(blob, filename);
        this.alertService.showMessage("Success", "Template is downloading.", MessageSeverity.success);
      },
      (error: any) => {
        this.alertService.stopLoadingMessage();
        this.alertService.showStickyMessage("Server Error", 
          `Unable to download template file.\r\nErrors: "${Utilities.getHttpResponseMessage(error)}"`,
          MessageSeverity.error, error);
        
      });
  }

  uploadFile() {
    if (!this.file) {
      this.alertService.showMessage("Form Error", "Please select a file to upload.", MessageSeverity.error);
      return;
    }

    this.isUploading = true;
    this.alertService.startLoadingMessage("", "Uploading file...");

    var odpProjectWorkflowId = 0;
    var protocolId = 0;
    if (this.accountService.GetActiveProject()) {
      odpProjectWorkflowId = this.accountService.GetActiveProject().odpProjectWorkflowId;
      protocolId = this.accountService.GetActiveProject().protocolId;
    }

    this.abstractService.importAbstract(this.file, odpProjectWorkflowId, protocolId).subscribe({
      next: _ => {
      this.file = undefined;
      this.isUploading = false;
      this.alertService.stopLoadingMessage();
      this.alertService.showMessage("Success", "File has been sucessfully imported.", MessageSeverity.success);
    }, error: (error) => {
      this.isUploading = false;
      this.alertService.stopLoadingMessage();
      this.alertService.showStickyMessage("Server Error", 
        `Unable to import file.\r\nErrors: "${Utilities.getHttpResponseMessage(error)}"`,
        MessageSeverity.error, error);
    }});
  }

  formatBytes(bytes: number, decimals: number = 2): string {
    if (!bytes) return bytes === 0 ? '0 Bytes' : '';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }
}
